<template>
  <q-page
    :data-test="CypressTarget('MyEventsRescuableEvents')"
  >
    <skeleton-event-list v-if="loading.events" />
    <sad-empty-error
      v-else-if="!eventArray.length && !loading.events"
      :text="$t('error.page.rescuableEvents')"
      @update="loadMore"
    />
    <q-pull-to-refresh
      v-else
      :handler="pullToRefresh"
    >
      <active-subscription-list-event-grid
        :event-list="eventArray"
        :card-display="cardDisplay"
        to-name="subscriptionRescuableEventInformation"
      />
    </q-pull-to-refresh>
  </q-page>
</template>

<script>
  // TODO Paginação dinâmica de eventos baseados em fim da pagina.
  import { mapActions, mapGetters } from 'vuex';

  export default {
    name: 'AvailableRescueEventList',
    components: {
      ActiveSubscriptionListEventGrid: () => import('activeComponent/subscription/list/eventGrid'),
      SkeletonEventList: () => import('skeleton/events/List'),
      SadEmptyError: () => import('components/error/sadEmpty'),
    },
    computed: {
      ...mapGetters('mySubscription', [
        'eventListByType',
        'recueTicketsAvaible',
        'loading',
      ]),
      eventArray() {
        return this.eventListByType('availableForRescue');
      },
      cardDisplay() {
        return {
 dateTime: true,
          description: false,
          main: true,
          name: true,
          place: false,
          serie: true,
          shortDescription: true,
...this.SET_DISPLAY.subscription.eventList.card,
};
      },
    },
    async created() {
      document.title = `${this.SET_PAGE_NAME} | ${this.$t('page.rescueEventList')}`;
      try {
        await this.getAvailableRescueEvents();
        await this.getAvailableRescueTickets();
      } catch (error) {
        this.toastError(error);
      }
    },
    mounted() {
      this.$tracker.pageView({
        page: this.$route.path,
        title: this.$t('page.rescueEventList'),
      });
    },
    methods: {
      ...mapActions('mySubscription', [
        'getAvailableRescueEvents',
        'getAvailableRescueTickets',
      ]),
      pullToRefresh(done) {
        this.loadMore()
          .then(() => {
            done();
          });
      },
      loadMore() {
        return this.getAvailableRescueEvents();
      },
    },
  };
</script>
